module.exports = __webpack_public_path__ + "a68f64c231ae1ae82470a14ef7a83665.svg";